import "./App.css";
import Home from "./Component/Home";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./Component/Header";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import Footer from "./Component/Footer";
import About from "./Component/About";
import Dr_Pawan_Kalyan from "./Component/Dr_Pawan_Kalyan";
import Dr_G_Sree_Lakshmi from "./Component/Dr_G_Sree_Lakshmi";
import Obstetric_And_Gynaecology from "./Component/Obstetric_And_Gynaecology";
import Fertility_Care from "./Component/Fertility_Care";
import Pediatric_Pulmonologist from "./Component/Pediatric_Pulmonologist";
import Cardiology from "./Component/Cardiology";
import Neurology from "./Component/Neurology";
import Gallery from "./Component/Gallery";
import Contact from "./Component/Contact";

function App() {
  return (
    <>
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/Home" element={<Home />} />
          <Route path="/About" element={<About />} />
          <Route path="/Dr_Pawan_Kalyan" element={<Dr_Pawan_Kalyan />} />
          <Route path="/Dr_G_Sree_Lakshmi" element={<Dr_G_Sree_Lakshmi />} />
          <Route
            path="/Obstetric_And_Gynaecology"
            element={<Obstetric_And_Gynaecology />}
          />
          <Route path="/Fertility_Care" element={<Fertility_Care />} />
          <Route
            path="/Pediatric_Pulmonologist"
            element={<Pediatric_Pulmonologist />}
          />
          <Route path="/Cardiology" element={<Cardiology />} />
          <Route path="/Neurology" element={<Neurology />} />
          <Route path="/Gallery" element={<Gallery />} />
          <Route path="/Contact" element={<Contact />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </>
  );
}

export default App;
